(() => {
  const SUPABASE_URL = 'https://rcstmyqltajacrfwiopn.supabase.co';
  const SUPABASE_KEY = 'sb_publishable_36xF9Fd9IZoDP9Diw7JtrQ_liqLAM9k';
  const SHOP = {
    name: 'YTE Sports',
    subtitle: 'Badminton Stringing Service',
    address1: 'GF-06, Oceanfront Residence',
    address2: 'Fithuroanu Magu, Hulhumale',
    address3: 'Maldives 23000',
    phone: '+960 977 1997',
    email: 'info@ytemv.com',
    website: 'www.ytemv.com'
  };



  // Shopify-backed suggestions captured from your active Shopify products.
  // Staff can still type a custom racket/string if customer brings something not in stock.
  const SHOPIFY_STRINGS = [
    { title: 'Yonex BG65 Badminton String', price: 399, stock: 7 },
    { title: 'Yonex BG66 Ultimax Badminton String', price: 480, stock: 6 },
    { title: 'Yonex Exbolt 63 Badminton String', price: 480, stock: 2 },
    { title: 'Yonex Exbolt 65 Badminton String - Green', price: 480, stock: 5 },
    { title: 'Yonex Exbolt 65 Badminton String - Red', price: 480, stock: 5 },
    { title: 'Yonex Exbolt 68 Badminton String - Red', price: 480, stock: 2 },
    { title: 'Yonex Exbolt 68 Badminton String - Teal', price: 480, stock: 2 },
    { title: 'Yonex Exbolt 68 Badminton String - Lime Green', price: 480, stock: 1 },
    { title: 'Yonex Exbolt 68 Badminton String - Orange', price: 480, stock: 2 }
  ];
  const SHOPIFY_RACKETS = [
    { title: 'Carlton GenZ100i Racket Set', stock: 1 },
    { title: 'Carlton GenZ100x Racket Set', stock: 1 },
    { title: 'Carlton S200 Racket Set', stock: 1 },
    { title: 'Hundred Flutter S Atk Badminton Racket - White/Golden', stock: 2 },
    { title: 'Hundred Flutter S Atk Badminton Racket - Black/Gold', stock: 1 },
    { title: 'Li Ning G-Force X5 Badminton Racket - White/Blue', stock: 3 },
    { title: 'Li Ning G-Force X5 Badminton Racket - Gold/White/Blue', stock: 1 },
    { title: 'Li-Ning Blaze 100 Badminton Racket', stock: 2 },
    { title: 'Yonex Arcsaber 0 Ability Badminton Racket', stock: 1 },
    { title: 'Yonex Astrox 01 Feel Badminton Racket', stock: 3 },
    { title: 'Yonex Astrox Lite 37i Badminton Racket - White/Green', stock: 12 },
    { title: 'Yonex Astrox Lite 37i Badminton Racket - White/Red', stock: 12 },
    { title: 'Yonex Astrox Lite 37i Badminton Racket - Purple', stock: 5 },
    { title: 'Yonex Astrox Lite 43i Badminton Racket - White', stock: 10 },
    { title: 'Yonex Astrox Lite 43i Badminton Racket - Light Blue', stock: 4 },
    { title: 'Yonex Astrox Lite 45i Badminton Racket - Black', stock: 5 },
    { title: 'Yonex Astrox Lite 45i Badminton Racket - Red', stock: 4 },
    { title: 'Yonex Astrox Lite 45i Badminton Racket - Light Blue', stock: 5 },
    { title: 'Yonex Nflare 001 Clear Badminton Racket', stock: 3 }
  ];

  const root = document.getElementById('yte-stringing-app');
  const logoUrl = root?.dataset.logoUrl || '';
  const STAFF_PIN = '1997';
  let staff = JSON.parse(localStorage.getItem('yte_stringing_staff') || 'null');
  let jobs = [];
  let selectedJob = null;
  let activeTab = 'new';
  let pollTimer = null;
  let documentCounter = null;
  let resetStep = 0;
  let theme = localStorage.getItem('yte_stringing_theme') || 'light';

  const nextReceiptNumber = () => {
    if (!documentCounter) return 'STR-0001';
    const prefix = documentCounter.prefix || 'STR-';
    const padding = Number(documentCounter.padding || 4);
    const next = Number(documentCounter.next_number || 1);
    return prefix + String(next).padStart(padding, '0');
  };

  const formatExpectedCompletion = (job) => {
    const date = shortDate(job.expected_completion);
    const time = job.expected_completion_time ? String(job.expected_completion_time).slice(0,5) : '';
    if (date === '—' && !time) return '—';
    return `${date}${time ? ' · ' + time : ''}`;
  };

  const splitExpectedDateTime = (value) => {
    if (!value) return { date: null, time: null };

    const [date, rawTime = ''] = String(value).split('T');
    if (!date || !rawTime) return { date: date || null, time: null };

    const [rawHour = '0', rawMinute = '0'] = rawTime.split(':');
    let hour = Math.max(0, Math.min(23, Number(rawHour) || 0));
    let minute = Number(rawMinute) || 0;

    // Only allow 30-minute intervals. If staff types a custom minute value,
    // round to nearest 00 or 30 so the saved value is always valid.
    minute = Math.round(minute / 30) * 30;
    if (minute === 60) {
      minute = 0;
      hour = Math.min(23, hour + 1);
    }

    return {
      date,
      time: `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
    };
  };



  const thirtyMinuteSelectOptions = () => {
    const options = [{ value: '', label: 'Time' }];
    for (let h = 0; h < 24; h++) {
      ['00', '30'].forEach(m => {
        const value = `${String(h).padStart(2, '0')}:${m}`;
        options.push({ value, label: value });
      });
    }
    return options;
  };

  const thirtyMinuteOptions = () => {
    const options = [];
    for (let h = 0; h < 24; h++) {
      ['00', '30'].forEach(m => {
        const value = `${String(h).padStart(2, '0')}:${m}`;
        options.push(`<option value="${value}">${value}</option>`);
      });
    }
    return options.join('');
  };




  const api = async (path, options = {}) => {
    const res = await fetch(`${SUPABASE_URL}/rest/v1/${path}`, {
      ...options,
      headers: {
        apikey: SUPABASE_KEY,
        Authorization: `Bearer ${SUPABASE_KEY}`,
        'Content-Type': 'application/json',
        Prefer: 'return=representation',
        ...(options.headers || {})
      }
    });
    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || `Request failed: ${res.status}`);
    }
    if (res.status === 204) return null;
    return res.json();
  };

  const rpc = async (fn, body = {}) => {
    const res = await fetch(`${SUPABASE_URL}/rest/v1/rpc/${fn}`, {
      method: 'POST',
      headers: {
        apikey: SUPABASE_KEY,
        Authorization: `Bearer ${SUPABASE_KEY}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || `RPC failed: ${res.status}`);
    }
    return res.json();
  };

  const escapeHtml = (value = '') => String(value)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;')
    .replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');

  const money = (value) => `MVR ${Number(value || 0).toFixed(2).replace('.00','')}`;
  const today = () => new Date().toISOString().slice(0,10);
  const shortDate = (date) => date ? new Date(date + 'T00:00:00').toLocaleDateString('en-GB', { day:'2-digit', month:'short', year:'numeric' }) : '—';
  const createdDate = (iso) => iso ? new Date(iso).toLocaleDateString('en-GB', { day:'2-digit', month:'short', year:'numeric' }) : shortDate(today());
  const normalizePhone = (phone) => String(phone || '').replace(/[^0-9]/g, '').replace(/^0+/, '');
  const intlPhone = (phone) => {
    const cleaned = normalizePhone(phone);
    if (!cleaned) return '';
    if (cleaned.startsWith('960')) return cleaned;
    if (cleaned.length === 7) return `960${cleaned}`;
    return cleaned;
  };

  const toast = (msg) => {
    const old = document.querySelector('.yte-toast');
    if (old) old.remove();
    const el = document.createElement('div');
    el.className = 'yte-toast';
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(() => el.remove(), 3200);
  };

  const applyTheme = () => {
    if (!root) return;
    root.classList.toggle('yte-theme-dark', theme === 'dark');
    root.classList.toggle('yte-theme-light', theme !== 'dark');
  };

  const toggleTheme = () => {
    theme = theme === 'dark' ? 'light' : 'dark';
    localStorage.setItem('yte_stringing_theme', theme);
    applyTheme();
    const btn = document.getElementById('theme-toggle');
    if (btn) btn.innerHTML = theme === 'dark' ? '<span aria-hidden="true">☀</span><strong>Light</strong>' : '<span aria-hidden="true">☾</span><strong>Dark</strong>';
  };

  const stringSourceLabel = (job) => job.string_source || 'YTE String';
  const serviceFee = (source) => source === 'Customer Own String' ? 50 : 0;
  const serviceFeeLabel = (job) => Number(job.stringing_fee ?? job.price ?? 0) === 0 ? 'Included' : money(job.stringing_fee ?? job.price ?? 0);

  const receiptLines = (job) => [
    ['Customer', job.customer_name],
    ['Contact Number', job.customer_phone],
    ['Date Received', createdDate(job.created_at)],
    ['Expected Completion', formatExpectedCompletion(job)],
    ['Racket', job.racket_model],
    ['String', job.string_type],
    ['Tension', job.tension],
    ['Service Fee', serviceFeeLabel(job)],
    ['Payment', job.payment_status]
  ];

  const receiptHtml = (job) => `
    <div class="yte-receipt-preview" id="receipt-preview">
      <div class="receipt-head">
        <img class="receipt-logo" src="${logoUrl}" alt="YTE Sports">
        <div class="receipt-title">
          <strong>${SHOP.name}</strong>
          <span>${SHOP.subtitle}</span>
        </div>
        <div class="receipt-status-badge">${escapeHtml(job.status || 'Received')}</div>
        <div class="receipt-job"><span>Receipt No.</span>${escapeHtml(job.job_number)}</div>
      </div>
      <div class="receipt-section">
        ${receiptLines(job).slice(0,4).map(([k,v]) => `<div class="receipt-line"><span>${k}</span><span>${escapeHtml(v || '—')}</span></div>`).join('')}
      </div>
      <div class="receipt-section">
        ${receiptLines(job).slice(4).map(([k,v]) => `<div class="receipt-line"><span>${k}</span><span>${escapeHtml(v || '—')}</span></div>`).join('')}
      </div>
      <div class="receipt-footer">
        <strong>Please retain this receipt for collection.</strong><br>
        YTE Sports is not responsible for pre-existing frame or grommet damage discovered during the stringing process.<br><br>
        ${SHOP.address1}<br>${SHOP.address2}<br>${SHOP.address3}<br>
        ${SHOP.phone} · ${SHOP.email}<br>${SHOP.website}
      </div>
    </div>`;

  const collectionText = (job) => `Hi ${job.customer_name}, your racket is ready for collection.\n\nReceipt No: ${job.job_number}\nRacket: ${job.racket_model}\n\nYou can collect it from YTE Sports. Thank you.`;
  const receiptText = (job) => `YTE Sports Stringing Receipt\nReceipt No: ${job.job_number}\nCustomer: ${job.customer_name}\nPhone: ${job.customer_phone}\nRacket: ${job.racket_model}\nString: ${job.string_type}\nTension: ${job.tension}\nService Fee: ${serviceFeeLabel(job)}`;

  async function imageBlob(job, mode = 'receipt') {
    /*
      v17: sharing must never fail.
      First try to render the exact backend receipt DOM. Some browsers, especially
      Safari/iOS or strict Shopify contexts, can block SVG foreignObject rendering.
      If that happens, use a reliable canvas fallback that keeps the same compact
      receipt proportions.
    */
    if (mode === 'receipt') {
      const live = document.getElementById('receipt-preview');
      if (live) {
        try {
          return await domElementToPngBlob(live);
        } catch (err) {
          console.warn('Backend receipt DOM image failed. Using canvas fallback.', err);
        }
      }

      try {
        const temp = document.createElement('div');
        temp.style.position = 'fixed';
        temp.style.left = '-99999px';
        temp.style.top = '0';
        temp.style.width = '520px';
        temp.style.pointerEvents = 'none';
        temp.innerHTML = receiptHtml(job);
        document.body.appendChild(temp);
        try {
          return await domElementToPngBlob(temp.querySelector('.yte-receipt-preview'));
        } finally {
          temp.remove();
        }
      } catch (err) {
        console.warn('Temporary receipt DOM image failed. Using canvas fallback.', err);
      }

      return await canvasReceiptBlob(job);
    }

    return await canvasReadyBlob(job);
  }

  async function canvasReceiptBlob(job) {
    const canvas = document.createElement('canvas');
    const scale = 3;
    const w = 520;
    const h = 742;
    canvas.width = w * scale;
    canvas.height = h * scale;
    const ctx = canvas.getContext('2d');
    ctx.scale(scale, scale);

    const bg = '#fffaf1';
    const ink = '#171310';
    const muted = '#655949';
    const label = '#735d40';
    const lineCol = 'rgba(116,83,39,.14)';
    const band = '#19130e';
    const gold = '#ead4a7';

    ctx.fillStyle = bg;
    roundRect(ctx, .5, .5, w - 1, h - 1, 24);
    ctx.fill();
    ctx.strokeStyle = 'rgba(114,82,42,.24)';
    ctx.lineWidth = 1;
    roundRect(ctx, .5, .5, w - 1, h - 1, 24);
    ctx.stroke();

    const img = await loadImage(logoUrl).catch(() => null);
    if (img) ctx.drawImage(img, 18, 18, 58, 58);

    ctx.fillStyle = ink;
    ctx.font = '800 20px Arial';
    ctx.fillText(SHOP.name, 84, 37);
    ctx.font = '16px Arial';
    ctx.fillStyle = muted;
    ctx.fillText(SHOP.subtitle, 84, 63);

    const badgeText = String(job.status || 'Received').toUpperCase();
    ctx.font = '900 11px Arial';
    const badgeW = Math.max(76, ctx.measureText(badgeText).width + 34);
    pill(ctx, badgeText, w - badgeW - 20, 26, badgeW, 34, gold, ink, 11);

    ctx.fillStyle = band;
    ctx.fillRect(0, 92, w, 84);
    ctx.fillStyle = '#d8c6a7';
    ctx.font = '900 10px Arial';
    ctx.textAlign = 'right';
    ctx.fillText('RECEIPT NO.', w - 20, 128);
    ctx.fillStyle = '#fff';
    ctx.font = '900 22px Arial';
    ctx.fillText(job.job_number || '—', w - 20, 154);
    ctx.textAlign = 'left';

    let y = 212;
    const rows = receiptLines(job);
    const labelX = 20;
    const valueX = 194;
    const rightX = w - 20;

    rows.forEach(([k, v], i) => {
      if (i === 4) {
        y += 12;
        line(ctx, 20, y - 8, rightX, y - 8, 'rgba(116,83,39,.20)');
        y += 12;
      }

      ctx.fillStyle = label;
      ctx.font = '900 10px Arial';
      ctx.fillText(String(k).toUpperCase(), labelX, y);

      ctx.fillStyle = ink;
      ctx.font = '800 16px Arial';
      wrapLimited(ctx, String(v || '—'), valueX, y, rightX - valueX, 19, 2);

      y += 34;
      line(ctx, 20, y - 14, rightX, y - 14, lineCol);
    });

    const fy = h - 172;
    line(ctx, 20, fy - 18, w - 20, fy - 18, 'rgba(116,83,39,.18)');
    ctx.textAlign = 'center';
    ctx.fillStyle = ink;
    ctx.font = '800 11px Arial';
    ctx.fillText('Please retain this receipt for collection.', w / 2, fy + 20);
    ctx.fillStyle = muted;
    ctx.font = '11px Arial';
    ctx.fillText('YTE Sports is not responsible for pre-existing frame or grommet damage', w / 2, fy + 40);
    ctx.fillText('discovered during the stringing process.', w / 2, fy + 56);
    ctx.fillText(SHOP.address1, w / 2, fy + 91);
    ctx.fillText(SHOP.address2, w / 2, fy + 109);
    ctx.fillText(SHOP.address3, w / 2, fy + 127);
    ctx.fillText(SHOP.phone + ' · ' + SHOP.email, w / 2, fy + 145);
    ctx.fillText(SHOP.website, w / 2, fy + 163);
    ctx.textAlign = 'left';

    return await new Promise(resolve => canvas.toBlob(resolve, 'image/png', 0.95));
  }

  async function canvasReadyBlob(job) {
    const canvas = document.createElement('canvas');
    const scale = 2;
    const w = 760;
    const h = 860;
    canvas.width = w * scale;
    canvas.height = h * scale;
    const ctx = canvas.getContext('2d');
    ctx.scale(scale, scale);

    const bg = '#fffaf1';
    const ink = '#171310';
    const muted = '#6b5d4b';
    const band = '#19130e';

    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, w, h);

    const img = await loadImage(logoUrl).catch(() => null);
    if (img) ctx.drawImage(img, 46, 42, 72, 72);
    ctx.fillStyle = ink;
    ctx.font = '800 30px Arial';
    ctx.fillText(SHOP.name, 140, 72);
    ctx.font = '20px Arial';
    ctx.fillStyle = muted;
    ctx.fillText(SHOP.subtitle, 140, 102);

    pill(ctx, 'READY', 580, 58, 128, 40, '#d9eadf', '#123d29');

    ctx.fillStyle = band;
    ctx.fillRect(0, 146, w, 76);
    ctx.fillStyle = '#d8c6a7';
    ctx.font = '700 13px Arial';
    ctx.fillText('RECEIPT NO.', 46, 193);
    ctx.fillStyle = '#ffffff';
    ctx.textAlign = 'right';
    ctx.font = '900 28px Arial';
    ctx.fillText(job.job_number || '—', w - 46, 195);
    ctx.textAlign = 'left';

    ctx.fillStyle = '#114b2f';
    ctx.font = '900 44px Arial';
    ctx.fillText('Ready for Collection', 46, 295);
    ctx.fillStyle = ink;
    ctx.font = '22px Arial';
    wrap(ctx, collectionText(job), 46, 350, 668, 34);

    return await new Promise(resolve => canvas.toBlob(resolve, 'image/png', 0.95));
  }

  async function domElementToPngBlob(sourceEl) {
    /*
      v18: What staff sees = what customer receives.
      Use html2canvas to screenshot the actual receipt card currently visible
      in the backend. This preserves the exact CSS layout, spacing, typography,
      borders, footer, and badge placement.
    */
    if (!sourceEl) throw new Error('Receipt preview not found');

    await ensureHtml2Canvas();

    const canvas = await window.html2canvas(sourceEl, {
      backgroundColor: null,
      scale: Math.max(2, Math.min(3, window.devicePixelRatio || 2)),
      useCORS: true,
      allowTaint: true,
      logging: false,
      scrollX: 0,
      scrollY: 0,
      windowWidth: document.documentElement.clientWidth,
      windowHeight: document.documentElement.clientHeight
    });

    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png', 0.95));
    if (!blob) throw new Error('Could not create PNG blob from receipt preview');
    return blob;
  }

  function ensureHtml2Canvas() {
    if (window.html2canvas) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-yte-html2canvas="true"]');
      if (existing) {
        existing.addEventListener('load', () => resolve(), { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js';
      script.async = true;
      script.defer = true;
      script.dataset.yteHtml2canvas = 'true';
      script.onload = () => resolve();
      script.onerror = () => reject(new Error('Could not load receipt screenshot library'));
      document.head.appendChild(script);
    });
  }

  function wrapLimited(ctx, text, x, y, maxWidth, lineHeight, maxLines = 2) {
    const words = String(text).split(/\s+/);
    const lines = [];
    let line = '';
    words.forEach(word => {
      const test = line ? line + ' ' + word : word;
      if (ctx.measureText(test).width > maxWidth && line) {
        lines.push(line);
        line = word;
      } else {
        line = test;
      }
    });
    if (line) lines.push(line);
    lines.slice(0, maxLines).forEach((ln, i) => {
      const finalLine = i === maxLines - 1 && lines.length > maxLines ? ln + '…' : ln;
      ctx.fillText(finalLine, x, y + i * lineHeight);
    });
  }

  function inlineComputedStyles(source, clone) {
    if (source.nodeType !== 1 || clone.nodeType !== 1) return;

    const computed = window.getComputedStyle(source);
    for (let i = 0; i < computed.length; i++) {
      const prop = computed[i];
      clone.style.setProperty(prop, computed.getPropertyValue(prop), computed.getPropertyPriority(prop));
    }

    if (clone.tagName === 'IMG' && clone.getAttribute('src')) {
      clone.setAttribute('src', new URL(clone.getAttribute('src'), window.location.href).href);
    }

    const sourceChildren = Array.from(source.children);
    const cloneChildren = Array.from(clone.children);
    sourceChildren.forEach((child, index) => inlineComputedStyles(child, cloneChildren[index]));
  }

  function loadImage(src, useCrossOrigin = true) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      if (useCrossOrigin) img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  }
  function line(ctx,x1,y1,x2,y2,color='rgba(17,17,17,.14)'){ ctx.strokeStyle=color; ctx.lineWidth=1; ctx.beginPath(); ctx.moveTo(x1,y1); ctx.lineTo(x2,y2); ctx.stroke(); }
  function pill(ctx,text,x,y,w,h,bg,fg,fontSize=16){ ctx.fillStyle=bg; roundRect(ctx,x,y,w,h,20); ctx.fill(); ctx.fillStyle=fg; ctx.font='800 '+fontSize+'px Arial'; ctx.textAlign='center'; ctx.fillText(text,x+w/2,y+(h/2)+(fontSize/2)-2); ctx.textAlign='left'; }
  function roundRect(ctx,x,y,w,h,r){ ctx.beginPath(); ctx.moveTo(x+r,y); ctx.arcTo(x+w,y,x+w,y+h,r); ctx.arcTo(x+w,y+h,x,y+h,r); ctx.arcTo(x,y+h,x,y,r); ctx.arcTo(x,y,x+w,y,r); ctx.closePath(); }
  function wrap(ctx, text, x, y, maxWidth, lineHeight) {
    const words = String(text).split(/\s+/); let line = '';
    words.forEach(word => {
      const test = line ? line + ' ' + word : word;
      if (ctx.measureText(test).width > maxWidth) { ctx.fillText(line, x, y); line = word; y += lineHeight; }
      else line = test;
    });
    if (line) ctx.fillText(line, x, y);
  }

  function wrapRight(ctx, text, x, y, maxWidth, lineHeight) {
    const words = String(text).split(/\s+/); let line = '';
    const lines = [];
    words.forEach(word => {
      const test = line ? line + ' ' + word : word;
      if (ctx.measureText(test).width > maxWidth) { lines.push(line); line = word; }
      else line = test;
    });
    if (line) lines.push(line);
    lines.slice(0,2).forEach((ln, i) => ctx.fillText(i === 1 && lines.length > 2 ? ln + '…' : ln, x, y + i * lineHeight));
  }

  async function shareJob(job, mode = 'receipt') {
    try {
      const blob = await imageBlob(job, mode);
      const file = new File([blob], `${mode}-${job.job_number}.png`, { type: 'image/png' });
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        // Share only the PNG. Adding text causes some apps to receive only text.
        await navigator.share({ files: [file] });
        return;
      }

      // Do NOT fall back to text-only when staff taps "Share Receipt Image".
      // Desktop WhatsApp/Viber URL schemes cannot receive an in-memory PNG attachment.
      // Instead, open the receipt image so staff can drag/copy it, while quick buttons remain text-only.
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank', 'noopener,noreferrer');
      toast('Image opened. On desktop, right-click/copy or drag this image into WhatsApp/Viber. Mobile shares it directly.');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (err) {
      if (!String(err.message || '').includes('AbortError')) toast('Image share failed. Try again or use quick text buttons.');
    }
  }


  function printReceipt(job) {
    /*
      v16: print the exact backend preview card.
      No separate print layout, no resized/rebuilt receipt.
    */
    const cssUrl = root?.dataset.cssUrl || '';
    const liveReceipt = document.getElementById('receipt-preview');
    const receiptMarkup = liveReceipt ? liveReceipt.outerHTML : receiptHtml(job);

    const html = `<!doctype html><html><head><title>Receipt ${escapeHtml(job.job_number || '')}</title>
      ${cssUrl ? `<link rel="stylesheet" href="${cssUrl}">` : ''}
      <style>
        html, body {
          margin: 0;
          padding: 0;
          background: transparent;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        body {
          font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
        }
        .print-stage {
          display: flex;
          justify-content: center;
          align-items: flex-start;
          padding: 0;
          margin: 0;
        }
        .print-stage .yte-receipt-preview {
          margin: 0 !important;
        }
        @page { margin: 0; }
        @media print {
          html, body { background: transparent !important; }
          .print-stage { padding: 0 !important; margin: 0 !important; }
        }
      </style></head><body><div class="print-stage">${receiptMarkup}</div><script>window.onload=()=>setTimeout(()=>window.print(),300)<\/script></body></html>`;

    const win = window.open('', '_blank', 'noopener,noreferrer');
    if (!win) { toast('Allow popups to print receipt'); return; }
    win.document.open();
    win.document.write(html);
    win.document.close();
  }

  const quickLinks = (job, mode = 'receipt') => {
    const phone = intlPhone(job.customer_phone);
    const body = encodeURIComponent(mode === 'ready' ? collectionText(job) : receiptText(job));
    const subject = encodeURIComponent(`${SHOP.name} ${mode === 'ready' ? 'Collection Notice' : 'Receipt'} ${job.job_number}`);
    // Chat openers only. Receipt/customer card image sharing is handled by the primary share buttons.
    return `
      <div class="yte-action-section yte-chat-section">
        <div class="yte-section-title">
          <span>Message Customer</span>
          <small>Open a chat without attaching receipt text</small>
        </div>
        <div class="yte-action-grid compact">
          <a class="yte-action-link" href="https://wa.me/${phone}" target="_blank" rel="noopener">WhatsApp</a>
          <a class="yte-action-link" href="viber://chat?number=%2B${phone}">Viber</a>
          <a class="yte-action-link" href="sms:+${phone}${mode === 'ready' ? `?&body=${body}` : ''}">SMS</a>
          <a class="yte-action-link" href="mailto:${encodeURIComponent(job.customer_email || '')}?subject=${subject}${mode === 'ready' ? `&body=${body}` : ''}">Email</a>
        </div>
      </div>`;
  };


  async function loadDocumentCounter() {
    try {
      const rows = await api('document_counter?select=*&id=eq.1&limit=1');
      documentCounter = rows?.[0] || { prefix: 'STR-', next_number: 1, padding: 4 };
    } catch (e) {
      documentCounter = { prefix: 'STR-', next_number: 1, padding: 4 };
    }
  }

  async function resetDocumentCounterToNext(nextNumber) {
    const cleanNumber = Number(nextNumber);
    if (!Number.isInteger(cleanNumber) || cleanNumber < 1) {
      toast('Enter a valid receipt number');
      return;
    }
    await rpc('reset_document_counter_to', { manual_next_number: cleanNumber });
    await loadDocumentCounter();
    resetStep = 0;
    toast(`Next receipt set to ${nextReceiptNumber()}`);
    render();
  }

  async function loadJobs(silent = false, shouldRender = true) {
    try {
      jobs = await api('jobs?select=*&order=created_at.desc&limit=200');
      if (selectedJob) selectedJob = jobs.find(j => j.id === selectedJob.id) || selectedJob;

      // Do not re-render the New Job form while staff are typing.
      // The old version refreshed every 12 seconds and rebuilt the whole form,
      // which looked like the form reset around the Price field.
      if (shouldRender && activeTab !== 'new') render();
      if (activeTab === 'new') updateTodayListOnly();
    } catch (e) { if (!silent) toast('Could not load jobs. Check Supabase connection.'); }
  }

  function updateTodayListOnly() {
    const wrap = document.getElementById('today-list-wrap');
    if (!wrap) return;
    wrap.innerHTML = jobList(jobs.slice(0,5));
    bindJobClicks();
  }

  async function login(pin) {
    // PIN-only access is intentionally local so multiple staff phones/desktops
    // can be logged in at the same time without Supabase Auth sessions kicking
    // each other out. Supabase stores the shared jobs; the PIN only unlocks UI.
    if (String(pin).trim() !== STAFF_PIN) throw new Error('Wrong PIN');
    staff = { name: 'Staff', id: 'pin-only' };
    localStorage.setItem('yte_stringing_staff', JSON.stringify(staff));
    activeTab = 'jobs';
    render();
    await loadJobs(true);
  }

  async function createJob(form) {
    const data = Object.fromEntries(new FormData(form).entries());
    if (!data.racket_select) throw new Error('Select racket');
    if (!data.string_select) throw new Error('Select string');
    const expected = splitExpectedDateTime(data.expected_completion_datetime);
    const payload = {
      customer_name: data.customer_name.trim(),
      customer_phone: data.customer_phone.trim(),
      contact_method: data.contact_method,
      customer_email: data.customer_email || null,
      racket_model: (data.racket_select === '__custom__' ? data.racket_custom : data.racket_select).trim(),
      string_type: (data.string_select === '__custom__' ? data.string_custom : data.string_select).trim(),
      tension: data.tension.trim(),
      string_source: data.string_source || 'YTE String',
      stringing_fee: serviceFee(data.string_source || 'YTE String'),
      price: serviceFee(data.string_source || 'YTE String'),
      expected_completion: expected.date,
      expected_completion_time: expected.time,
      status: 'Received',
      payment_status: data.payment_status || 'Unpaid',
      notes: data.notes || null,
      staff_name: staff?.name || 'Staff'
    };
    const [job] = await api('jobs', { method:'POST', body: JSON.stringify(payload) });
    selectedJob = job; activeTab = 'jobs';
    form.reset();
    await loadDocumentCounter();
    await loadJobs(true, false);
    toast(`Receipt ${job.job_number} created`);
  }

  async function updateStatus(job, status) {
    const [updated] = await api(`jobs?id=eq.${job.id}`, { method:'PATCH', body: JSON.stringify({ status, staff_name: staff?.name || 'Staff' }) });
    selectedJob = updated;
    await loadJobs(true, false);
    toast(`Marked ${status}`);
  }

  async function deleteJob(job) {
    if (!job) return;
    const ok = confirm(`Delete job ${job.job_number}?\n\nThis cannot be undone.`);
    if (!ok) return;
    await api(`jobs?id=eq.${job.id}`, { method:'DELETE' });
    selectedJob = null;
    await loadJobs(true, false);
    toast('Job deleted');
    render();
  }


  function renderLogin() {
    root.innerHTML = `
      <div class="yte-login">
        <img class="yte-login-logo" src="${logoUrl}" alt="YTE Sports">
        <h1>Stringing Staff</h1>
        <p>Enter staff PIN to access the racket stringing system.</p>
        <form id="login-form" class="yte-form">
          <div class="yte-field"><label>Staff PIN</label><input name="pin" type="password" inputmode="numeric" autocomplete="off" required autofocus></div>
          <button class="yte-button primary" type="submit">Open App</button>
        </form>
      </div>`;
    applyTheme();
    document.getElementById('login-form').addEventListener('submit', async (e) => {
      e.preventDefault();
      try { await login(e.target.pin.value); }
      catch { toast('Wrong PIN'); }
    });
  }

  function renderShell(content) {
    root.innerHTML = `
      <div class="yte-topbar">
        <div class="yte-brand-row">
          <div class="yte-brand"><img src="${logoUrl}" alt="YTE"><div><strong>YTE Stringing</strong><span>${staff?.name || 'Staff'} · Next receipt ${escapeHtml(nextReceiptNumber())}</span></div></div>
          <div class="yte-top-actions"><button class="yte-theme-button" id="theme-toggle" title="Toggle dark mode" aria-label="Toggle dark mode">${theme === 'dark' ? '<span aria-hidden="true">☀</span><strong>Light</strong>' : '<span aria-hidden="true">☾</span><strong>Dark</strong>'}</button><button class="yte-logout-button" id="logout" title="Logout" aria-label="Logout"><span aria-hidden="true">↪</span><strong>Logout</strong></button></div>
        </div>
        <div class="yte-tabs">
          <button class="yte-tab ${activeTab==='new'?'active':''}" data-tab="new">+ New Job</button>
          <button class="yte-tab ${activeTab==='jobs'?'active':''}" data-tab="jobs">Active Jobs</button>
          <button class="yte-tab ${activeTab==='ready'?'active':''}" data-tab="ready">✓ Ready</button>
          <button class="yte-tab ${activeTab==='collected'?'active':''}" data-tab="collected">◌ Collected</button>
          <button class="yte-tab ${activeTab==='settings'?'active':''}" data-tab="settings">⚙ Settings</button>
        </div>
      </div>
      ${content}`;
    applyTheme();
    document.getElementById('theme-toggle').onclick = toggleTheme;
    document.getElementById('logout').onclick = () => { localStorage.removeItem('yte_stringing_staff'); staff = null; renderLogin(); };
    document.querySelectorAll('[data-tab]').forEach(btn => btn.onclick = () => { activeTab = btn.dataset.tab; render(); });
  }


  async function fetchShopifySuggestions(kind, query = '') {
    const q = query || (kind === 'string' ? 'badminton string' : 'badminton racket');
    try {
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10`;
      const res = await fetch(url, { headers: { Accept: 'application/json' } });
      if (!res.ok) return [];
      const data = await res.json();
      const products = data?.resources?.results?.products || [];
      return products
        .filter(p => {
          const hay = `${p.title || ''} ${p.product_type || ''}`.toLowerCase();
          return kind === 'string' ? hay.includes('string') : hay.includes('racket');
        })
        .map(p => ({ title: p.title, price: p.price ? Number(String(p.price).replace(/[^0-9.]/g,'')) : null, stock: 'Shopify' }));
    } catch { return []; }
  }

  async function enrichProductDatalist(input, datalistId, kind) {
    const list = document.getElementById(datalistId);
    if (!input || !list) return;
    const live = await fetchShopifySuggestions(kind, input.value);
    const base = kind === 'string' ? SHOPIFY_STRINGS : SHOPIFY_RACKETS;
    const merged = [...live, ...base].filter((item, index, arr) => item.title && arr.findIndex(x => x.title === item.title) === index).slice(0, 20);
    list.innerHTML = merged.map(p => `<option value="${escapeHtml(p.title)}">${p.price ? 'MVR ' + p.price + ' · ' : ''}Stock: ${p.stock ?? '—'}</option>`).join('');
  }


  const customSelectHtml = (name, options, selectedValue = '', placeholder = 'Select', id = '') => {
    const selected = options.find(o => String(o.value) === String(selectedValue)) || options.find(o => String(o.value) === '') || options[0];
    const safeId = id ? ` id="${id}"` : '';
    const inputValue = escapeHtml(selectedValue || selected?.value || '');
    const label = escapeHtml(selected?.label || placeholder);
    return `
      <div class="yte-custom-select" data-custom-select>
        <input type="hidden" name="${escapeHtml(name)}"${safeId} value="${inputValue}">
        <button type="button" class="yte-custom-select-button" data-custom-select-toggle>
          <span data-custom-select-label>${label}</span>
          <i aria-hidden="true">⌄</i>
        </button>
        <div class="yte-custom-select-menu" data-custom-select-menu>
          ${options.map(o => `
            <button type="button" data-custom-select-option data-value="${escapeHtml(o.value)}" data-label="${escapeHtml(o.label)}">
              ${escapeHtml(o.label)}
            </button>
          `).join('')}
        </div>
      </div>`;
  };

  function initCustomSelects(scope = document) {
    const closeAll = (except = null) => {
      scope.querySelectorAll('[data-custom-select].is-open').forEach(el => {
        if (el !== except) el.classList.remove('is-open');
      });
    };

    scope.querySelectorAll('[data-custom-select]').forEach(select => {
      const hidden = select.querySelector('input[type="hidden"]');
      const label = select.querySelector('[data-custom-select-label]');
      const toggle = select.querySelector('[data-custom-select-toggle]');
      const options = select.querySelectorAll('[data-custom-select-option]');

      const current = Array.from(options).find(o => o.dataset.value === hidden.value);
      if (current && label) label.textContent = current.dataset.label || current.textContent.trim();

      toggle.onclick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const willOpen = !select.classList.contains('is-open');
        closeAll(select);
        select.classList.toggle('is-open', willOpen);
      };

      options.forEach(option => {
        option.onclick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          hidden.value = option.dataset.value || '';
          if (label) label.textContent = option.dataset.label || option.textContent.trim();
          select.classList.remove('is-open');
          hidden.dispatchEvent(new Event('change', { bubbles: true }));
        };
      });
    });

    document.addEventListener('click', () => closeAll(), { once: true });
  }


  function renderNew() {
    renderShell(`
      <div class="yte-grid two">
        <div class="yte-card">
          <h2>New Stringing Job</h2>
          <form id="job-form" class="yte-form">
            <div class="yte-field"><label>Customer Name</label><input name="customer_name" required placeholder="Ahmed"></div>
            <div class="yte-row">
              <div class="yte-field"><label>Contact Number</label><input name="customer_phone" inputmode="tel" required placeholder="7771234"></div>
              <div class="yte-field"><label>Preferred Contact</label>${customSelectHtml('contact_method', [
                { value: 'WhatsApp', label: 'WhatsApp' },
                { value: 'Viber', label: 'Viber' },
                { value: 'SMS', label: 'SMS' },
                { value: 'Email', label: 'Email' },
                { value: 'Call', label: 'Call' }
              ], 'WhatsApp')}</div>
            </div>
            <div class="yte-field"><label>Email Optional</label><input name="customer_email" type="email" placeholder="customer@email.com"></div>
            <div class="yte-field"><label>Racket Model</label>${customSelectHtml('racket_select', [
                { value: '', label: 'Choose racket / customer racket' },
                { value: '__custom__', label: '+ Custom racket' },
                ...SHOPIFY_RACKETS.map(p => ({ value: p.title, label: `${p.title} · Stock: ${p.stock}` }))
              ], '', 'Choose racket / customer racket', 'racket-select')}<input class="yte-hidden-input" name="racket_custom" id="racket-custom" placeholder="Type custom racket model"></div>
            <div class="yte-row">
              <div class="yte-field"><label>String</label>${customSelectHtml('string_select', [
                { value: '', label: 'Choose string' },
                { value: '__custom__', label: '+ Custom string' },
                ...SHOPIFY_STRINGS.map(p => ({ value: p.title, label: `${p.title} · MVR ${p.price} · Stock: ${p.stock}` }))
              ], '', 'Choose string', 'string-select')}<input class="yte-hidden-input" name="string_custom" id="string-custom" placeholder="Type custom string"></div>
              <div class="yte-field"><label>Tension</label><input name="tension" required placeholder="26 lbs"></div>
            </div>
            <div class="yte-field">
              <label>String Source</label>
              <div class="yte-price-cards">
                <label class="yte-price-card is-active">
                  <input type="radio" name="string_source" value="YTE String" checked>
                  <strong>Bought String From YTE</strong>
                  <span>Stringing included</span>
                  <b>MVR 0</b>
                </label>
                <label class="yte-price-card">
                  <input type="radio" name="string_source" value="Customer Own String">
                  <strong>Customer Own String</strong>
                  <span>Labour charge</span>
                  <b>MVR 50</b>
                </label>
              </div>
              <div class="yte-service-summary" id="service-summary">Service Fee: <strong>Included</strong></div>
            </div>
            <div class="yte-field"><label>Payment</label>${customSelectHtml('payment_status', [
                { value: 'Unpaid', label: 'Unpaid' },
                { value: 'Paid', label: 'Paid' }
              ], 'Unpaid')}</div>
            <div class="yte-field">
              <label>Expected Completion</label>
              <div class="yte-combined-datetime">
                <input name="expected_completion_date" type="date" aria-label="Expected completion date">
                ${customSelectHtml('expected_completion_time_select', thirtyMinuteSelectOptions(), '', 'Time')}
              </div>
              <input name="expected_completion_datetime" type="hidden">
            </div>
            <div class="yte-field"><label>Internal Notes</label><textarea name="notes" placeholder="Scratches, cracked grommets, customer requests…"></textarea></div>
            <button class="yte-button primary" type="submit">Create Receipt</button>
          </form>
        </div>
        <div class="yte-card"><h2>Today</h2><div id="today-list-wrap">${jobList(jobs.slice(0,5))}</div></div>
      </div>`);
    const jobForm = document.getElementById('job-form');
    initCustomSelects(jobForm);
    const enhanceFormSelects = () => {
      document.querySelectorAll('#job-form select').forEach(select => {
        if (select.closest('.yte-select-control')) return;
        const wrap = document.createElement('span');
        wrap.className = 'yte-select-control';
        select.parentNode.insertBefore(wrap, select);
        wrap.appendChild(select);
        const arrow = document.createElement('span');
        arrow.className = 'yte-select-arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '⌄';
        wrap.appendChild(arrow);
      });
    };
    enhanceFormSelects();
    jobForm.onsubmit = async (e) => { e.preventDefault(); try { await createJob(e.target); } catch (err) { toast('Could not create job'); console.error(err); } };

    const expectedHidden = document.querySelector('input[name="expected_completion_datetime"]');
    const expectedDate = document.querySelector('input[name="expected_completion_date"]');
    const expectedTime = document.querySelector('select[name="expected_completion_time_select"]');
    const syncExpectedDateTime = () => {
      if (!expectedHidden || !expectedDate || !expectedTime) return;
      expectedHidden.value = expectedDate.value && expectedTime.value
        ? `${expectedDate.value}T${expectedTime.value}`
        : '';
    };
    [expectedDate, expectedTime].forEach(el => el && el.addEventListener('change', syncExpectedDateTime));
    const racketSelect = document.getElementById('racket-select');
    const stringSelect = document.getElementById('string-select');
    const racketCustom = document.getElementById('racket-custom');
    const stringCustom = document.getElementById('string-custom');
    const syncProductPickers = () => {
      if (racketCustom) {
        racketCustom.classList.toggle('is-visible', racketSelect.value === '__custom__');
        racketCustom.required = racketSelect.value === '__custom__';
      }
      if (stringCustom) {
        stringCustom.classList.toggle('is-visible', stringSelect.value === '__custom__');
        stringCustom.required = stringSelect.value === '__custom__';
      }
    };
    racketSelect.addEventListener('change', syncProductPickers);
    stringSelect.addEventListener('change', () => {
      // Product selection identifies the string used only. Product price is not charged in this service portal.
      syncProductPickers();
    });
    document.querySelectorAll('input[name="string_source"]').forEach(input => {
      input.addEventListener('change', () => {
        document.querySelectorAll('.yte-price-card').forEach(card => card.classList.toggle('is-active', card.querySelector('input').checked));
        const summary = document.getElementById('service-summary');
        const fee = serviceFee(input.value);
        if (summary) summary.innerHTML = `Service Fee: <strong>${fee === 0 ? 'Included' : money(fee)}</strong>`;
      });
    });
    syncProductPickers();
    bindJobClicks();
  }

  function jobList(list) {
    if (!list.length) return `<div class="yte-empty">No jobs yet.</div>`;
    return `<div class="yte-list">${list.map(j => `
      <button class="yte-job-item" data-job-id="${j.id}">
        <div class="yte-job-head"><strong>${escapeHtml(j.customer_name)}</strong><span class="yte-pill ${j.status === 'Ready for Collection' ? 'ready' : j.status === 'Cancelled' ? 'cancelled' : ''}">${escapeHtml(j.status)}</span></div>
        <div class="yte-job-meta"><span>Receipt No. ${escapeHtml(j.job_number)}</span><span>${escapeHtml(j.customer_phone)}</span><span>Prefers: ${escapeHtml(j.contact_method || '—')}</span><span>${escapeHtml(j.racket_model)}</span><span>${escapeHtml(j.string_type)}</span><span>${escapeHtml(stringSourceLabel(j))}</span><span>Fee: ${escapeHtml(serviceFeeLabel(j))}</span><span>Ready: ${escapeHtml(formatExpectedCompletion(j))}</span></div>
      </button>`).join('')}</div>`;
  }


  function renderSettings() {
    const current = nextReceiptNumber();
    renderShell(`
      <div class="yte-grid one">
        <div class="yte-card yte-settings-card">
          <h2>⚙ Settings</h2>
          <div class="yte-counter-card">
            <span>Next Receipt</span>
            <strong>${escapeHtml(current)}</strong>
            <small>New jobs will use simple sequential receipt numbers like STR-0001.</small>
          </div>
          <h3>Receipt Numbering</h3>
          <p class="yte-muted-text">Resetting changes the next receipt number for all staff devices. Use this only when starting a new sequence.</p>
          <div id="reset-panel" class="yte-reset-panel">
            ${resetPanelHtml()}
          </div>
        </div>
      </div>`);
    bindResetPanel();
  }

  function resetPanelHtml() {
    const prefix = documentCounter?.prefix || 'STR-';
    const padding = Number(documentCounter?.padding || 4);
    const nextNumber = Number(documentCounter?.next_number || 1);
    const lastUsed = Math.max(0, nextNumber - 1);
    const formatNo = (num) => prefix + String(Math.max(0, Number(num) || 0)).padStart(padding, '0');

    if (resetStep === 0) {
      return `<button class="yte-button danger" data-reset-step="1">Reset Counter</button>`;
    }
    if (resetStep === 1) {
      return `<div class="yte-warning"><strong>Are you sure?</strong><span>This affects future receipt numbers for every staff device.</span></div><div class="yte-actions"><button class="yte-button ghost" data-reset-cancel="true">Cancel</button><button class="yte-button gold" data-reset-step="2">Continue</button></div>`;
    }
    if (resetStep === 2) {
      return `<div class="yte-warning"><strong>This cannot be undone.</strong><span>Only continue if you are intentionally correcting the receipt sequence.</span></div><div class="yte-actions"><button class="yte-button ghost" data-reset-cancel="true">Cancel</button><button class="yte-button gold" data-reset-step="3">Continue</button></div>`;
    }

    return `
      <div class="yte-warning">
        <strong>Set receipt sequence</strong>
        <span>Edit the last used number. The app will use the next number for the next new job.</span>
      </div>
      <div class="yte-reset-form">
        <div class="yte-reset-readout">
          <span>Last used receipt</span>
          <strong id="last-receipt-preview">${escapeHtml(formatNo(lastUsed))}</strong>
        </div>
        <label class="yte-field">
          <span>Last used sequence number</span>
          <input id="manual-last-used" type="number" min="0" step="1" inputmode="numeric" value="${lastUsed}">
        </label>
        <div class="yte-reset-readout next">
          <span>Next receipt will be</span>
          <strong id="next-receipt-preview">${escapeHtml(formatNo(nextNumber))}</strong>
        </div>
      </div>
      <div class="yte-actions">
        <button class="yte-button ghost" data-reset-cancel="true">Cancel</button>
        <button class="yte-button danger" id="save-manual-reset">Save Sequence</button>
      </div>`;
  }

  function bindResetPanel() {
    document.querySelectorAll('[data-reset-step]').forEach(btn => btn.onclick = () => { resetStep = Number(btn.dataset.resetStep); renderSettings(); });
    document.querySelectorAll('[data-reset-cancel]').forEach(btn => btn.onclick = () => { resetStep = 0; renderSettings(); });

    const manualInput = document.getElementById('manual-last-used');
    const lastPreview = document.getElementById('last-receipt-preview');
    const nextPreview = document.getElementById('next-receipt-preview');
    const saveButton = document.getElementById('save-manual-reset');
    const prefix = documentCounter?.prefix || 'STR-';
    const padding = Number(documentCounter?.padding || 4);
    const formatNo = (num) => prefix + String(Math.max(0, Number(num) || 0)).padStart(padding, '0');

    if (manualInput) {
      manualInput.addEventListener('input', () => {
        const last = Math.max(0, Number(manualInput.value || 0));
        if (lastPreview) lastPreview.textContent = formatNo(last);
        if (nextPreview) nextPreview.textContent = formatNo(last + 1);
      });
    }

    if (saveButton) {
      saveButton.onclick = async () => {
        try {
          const last = Math.max(0, Number(manualInput?.value || 0));
          if (!Number.isInteger(last)) {
            toast('Enter a whole number');
            return;
          }
          await resetDocumentCounterToNext(last + 1);
        } catch (e) {
          console.error(e);
          toast('Could not reset receipt counter');
        }
      };
    }
  }

  function renderJobs() {
    const filtered = activeTab === 'ready' ? jobs.filter(j => j.status === 'Ready for Collection') : activeTab === 'collected' ? jobs.filter(j => j.status === 'Collected') : jobs.filter(j => j.status !== 'Collected' && j.status !== 'Cancelled');
    const title = activeTab === 'ready' ? 'Ready for Collection' : activeTab === 'collected' ? 'Collected Jobs' : 'Active Jobs';
    renderShell(`
      <div class="yte-grid two">
        <div class="yte-card">
          <h2>${title}</h2>
          <div class="yte-search"><input id="search" placeholder="Search name, phone, racket…"><button class="yte-button ghost" id="refresh">Refresh</button></div>
          <div id="job-list-wrap">${jobList(filtered)}</div>
        </div>
        <div class="yte-card" id="detail-wrap">${selectedJob ? detailHtml(selectedJob) : '<div class="yte-empty">Select a job to view receipt and actions.</div>'}</div>
      </div>`);
    document.getElementById('refresh').onclick = () => loadJobs();
    document.getElementById('search').oninput = (e) => {
      const q = e.target.value.toLowerCase();
      const base = activeTab === 'ready' ? jobs.filter(j => j.status === 'Ready for Collection') : activeTab === 'collected' ? jobs.filter(j => j.status === 'Collected') : jobs.filter(j => j.status !== 'Collected' && j.status !== 'Cancelled');
      const list = base.filter(j => [j.customer_name,j.customer_phone,j.contact_method,j.racket_model,j.string_type,j.job_number,j.status].join(' ').toLowerCase().includes(q));
      document.getElementById('job-list-wrap').innerHTML = jobList(list);
      bindJobClicks();
    };
    bindJobClicks(); bindDetail();
  }

  function detailHtml(j) {
    return `
      <h2>${escapeHtml(j.customer_name)}</h2>
      ${receiptHtml(j)}
      <div class="yte-backend-panel"><strong>Internal staff info</strong><div>Preferred contact: <b>${escapeHtml(j.contact_method || '—')}</b></div><div>String source: <b>${escapeHtml(stringSourceLabel(j))}</b></div><div>Service fee: <b>${escapeHtml(serviceFeeLabel(j))}</b></div><div>Notes: ${escapeHtml(j.notes || '—')}</div></div>
      <div class="yte-action-panel">
        <div class="yte-action-section">
          <div class="yte-section-title">
            <span>Receipt Actions</span>
            <small>Share exactly what staff sees</small>
          </div>
          <button class="yte-button primary yte-primary-share" data-share="receipt">Share Receipt</button>
          <div class="yte-action-grid secondary">
            <button class="yte-action-link" data-share="ready">Share Ready Card</button>
            <button class="yte-action-link" data-print-receipt="true">Print Receipt</button>
          </div>
        </div>

        ${quickLinks(j, j.status === 'Ready for Collection' ? 'ready' : 'receipt')}

        <div class="yte-action-section">
          <div class="yte-section-title">
            <span>Job Status</span>
            <small>Move the racket through the workflow</small>
          </div>
          <div class="yte-status-control">
            <button class="${j.status === 'Received' ? 'active ' : ''}received" data-status="Received">Received</button>
            <button class="${j.status === 'In Progress' ? 'active ' : ''}progress" data-status="In Progress">In Progress</button>
            <button class="${j.status === 'Ready for Collection' ? 'active ' : ''}ready" data-status="Ready for Collection">Ready</button>
            <button class="${j.status === 'Collected' ? 'active ' : ''}collected" data-status="Collected">Collected</button>
          </div>
        </div>

        <div class="yte-action-section danger-zone">
          <div class="yte-section-title">
            <span>Danger Zone</span>
            <small>Permanent action</small>
          </div>
          <button class="yte-danger-link" data-delete-job="true">Delete Job</button>
        </div>
      </div>`;
  }

  function bindJobClicks() {
    document.querySelectorAll('[data-job-id]').forEach(el => el.onclick = () => { selectedJob = jobs.find(j => j.id === el.dataset.jobId); activeTab = 'jobs'; render(); });
  }
  function bindDetail() {
    document.querySelectorAll('[data-share]').forEach(el => el.onclick = () => shareJob(selectedJob, el.dataset.share === 'ready' ? 'ready' : 'receipt'));
    document.querySelectorAll('[data-status]').forEach(el => el.onclick = () => updateStatus(selectedJob, el.dataset.status));
    document.querySelectorAll('[data-print-receipt]').forEach(el => el.onclick = () => printReceipt(selectedJob));
    document.querySelectorAll('[data-delete-job]').forEach(el => el.onclick = () => deleteJob(selectedJob));
  }

  function render() {
    if (!staff) return renderLogin();
    if (activeTab === 'new') renderNew(); else if (activeTab === 'settings') renderSettings(); else renderJobs();
  }

  async function start() {
    applyTheme();
    await loadDocumentCounter();
    if (!staff) renderLogin();
    else { render(); await loadJobs(true); }
    if (pollTimer) clearInterval(pollTimer);
    pollTimer = setInterval(() => { if (staff) loadJobs(true); }, 12000);
  }

  start();
})();
